<template>
  <div class="list-consultings-admin">
    <navigator :items="items"></navigator>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12">
                  <h5>Filtros</h5>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="filter.description"
                      placeholder="Termo"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <select v-model="filter.client" class="form-control">
                      <option value="0">Todos os Clientes</option>
                      <option
                        v-for="client in clients"
                        :value="client.id"
                        v-bind:key="client.id"
                      >{{client.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <select
                      v-model="filter.status"
                      id
                      class="form-control"
                      v-on:change="filterTable()"
                    >
                      <option value>Todos os status</option>
                      <option v-for="type in status" :value="type" v-bind:key="type">{{type}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3">
                  <b-form-datepicker
                    id="start-datepicker"
                    v-model="filter.start_date"
                    placeholder="Data de inicio (resposta)"
                    class="mb-2"
                  ></b-form-datepicker>
                </div>
                <div class="col-lg-3">
                  <b-form-datepicker
                    id="end-datepicker"
                    v-model="filter.end_date"
                    placeholder="Data de final (resposta)"
                    class="mb-2"
                  ></b-form-datepicker>
                </div>
                <div class="col-lg-12">
                  <button
                    class="btn btn-secondary"
                    style="margin-right: 18px"
                    v-on:click="filterClear()"
                  >Limpar filtros</button>
                  <button class="btn btn-primary" v-on:click="filterTable()">Pesquisar</button>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label>
                    Consultorias encontradas:
                    <span class="consulResult">{{this.rows}}</span>
                  </label>

                  <b-table
                    hover
                    :fields="fields"
                    :items="data"
                    :per-page="0"
                    :current-page="currentPage"
                    @row-clicked="selectItemTable"
                  >
                    <template v-slot:cell(created_at)="data">{{formatDate(data.value)}}</template>
                    <template v-slot:cell(consulting_answer.created_at)="data">
                      {{data.value ? formatDate(data.value) : '-'}}
                      <i
                        class="fa fa-external-link-square open-answer"
                        v-if="data.value"
                        aria-hidden="true"
                      ></i>
                    </template>
                    <template v-slot:cell(rating)="data">
                      <i
                        v-for="(start, index) in data.value"
                        v-bind:key="index"
                        class="fa fa-star rating-star"
                        aria-hidden="true"
                      ></i>
                    </template>
                  </b-table>
                  <div class="total-data" v-if="data.length > 0 && filter.client != 0 && showTotal">
                    <span>{{rows}} consultorias encontradas para o cliente</span>
                  </div>
                  <div class="no-data" v-if="data.length == 0">
                    <span>Sem dados</span>
                  </div>
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="answer-modal" id="answer-modal" size="lg" title="Resposta" @ok="editConsulting()">
      <div class="info-content" style="max-height: 75vh; overflow-y: auto">
        <div v-html="answer_content" class="text-content" v-bind:key="answer_content"></div>
      </div>
      <template v-slot:modal-cancel>Fechar</template>
      <template v-slot:modal-ok>Editar consultoria</template>
    </b-modal>
  </div>
</template>

<script>
import axios from "@/api/axios";
import { bus } from "@/main";
import moment from "moment";

export default {
  name: "list-consultings-admin",
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      showTotal: false,
      items: [
        {
          text: "Consultorias",
          active: true,
        },
      ],
      data: [],
      fields: [
        { key: "id", label: "ID" },
        { key: "subject", label: "Assunto" },
        { key: "user.name", label: "Usuário" },
        { key: "user.client.name", label: "Cliente" },
        { key: "created_at", label: "Enviado" },
        { key: "consulting_answer.created_at", label: "Respondido" },
        { key: "rating", label: "Avaliação" },
        { key: "status", label: "Situação" },
      ],
      filter: {
        status: "",
        client: 0,
        description: "",
      },
      status: [],
      clients: [],
      answer_content: "",
      reading_consulting: 0,
    };
  },
  mounted() {
    this.getSavedData();
    bus.$emit("changeLoading", true);
    this.getCreateParams();
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.providerData();
      },
    },
  },
  methods: {
    filterClear() {
      this.filter = {
        status: "",
        client: 0,
        description: "",
      };
    },
    filterTable() {
      this.currentPage = 1;
      this.providerData();
    },
    providerData() {
      this.showTotal = this.filter.client != 0;
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/consultings?${this.urlBuild()}`
        )
        .then((response) => {
          this.rows = response.data.total;
          this.data = response.data.data;
          bus.$emit("changeLoading", false);
        });
    },
    getSavedData: function () {
      if (
        localStorage.getItem("filters_search_consultings") != null &&
        localStorage.getItem("filters_search_consultings") != ""
      ) {
        var data = JSON.parse(
          localStorage.getItem("filters_search_consultings")
        );
        this.filter = data.filter;
      }
    },
    saveDataOnStorage: function () {
      let filters = {
        filter: this.filter,
      };
      localStorage.setItem(
        "filters_search_consultings",
        JSON.stringify(filters)
      );
    },
    urlBuild: function () {
      this.saveDataOnStorage();
      let url =
        "sort=-created_at&include=consulting_answer.user,user.client&page[number]=" +
        this.currentPage +
        "&page[size]=" +
        this.perPage +
        (this.filter.description != ""
          ? `&filter[description]=${this.filter.description}`
          : "") +
        (this.filter.status != ""
          ? `&filter[status]=${this.filter.status}`
          : "") +
        (this.filter.client != 0
          ? `&filter[user.client_id]=${this.filter.client}`
          : "") +
        (this.filter.start_date
          ? `&filter[answered_after]=${this.filter.start_date}`
          : "") +
        (this.filter.end_date
          ? `&filter[answered_before]=${this.filter.end_date}`
          : "");
      return url;
    },
    selectItemTable: function (record, index) {
      if (!record.consulting_answer) {
        this.$router.push({
          name: "admin.consulting-answer",
          params: { id: record.id },
        });
      } else {
        this.$refs["answer-modal"].show();
        this.reading_consulting = record.id;
        this.answer_content = record.consulting_answer.answer;
      }
    },
    getCreateParams: function () {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/consultings/create`)
        .then((data) => {
          this.status = data.data.status;
          this.clients = data.data.clients;
          this.providerData();
        });
    },
    editConsulting: function () {
      this.$router.push({
        name: "admin.consulting-answer",
        params: { id: this.reading_consulting },
      });
    },
    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY, H:MM:SS ");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.rating-star {
  color: gold;
}
.consulResult {
  color: #e12323;
}
.open-answer {
  color: $red_primary;
  margin-left: 6px;
}
</style>